import {
  ContentChild,
  Directive,
  ElementRef,
  Input,
  TemplateRef,
} from '@angular/core';

@Directive({
    selector: '[stdoutTableColumn]',
    standalone: false
})
export class TableColumnDirective {
  @Input() property!: string;
  @Input() label!: string;
  @Input() width!: string;
  @Input() selected!: boolean;
  @Input() classes!: string;

  @ContentChild('dataTableCell', { static: false }) cellTemplate!: ElementRef;
  @ContentChild('dataTableHeader', { static: false })
  headerTemplate!: TemplateRef<any>;
}
